export default "__VITE_ASSET__469eb6cf__"